import { Box } from '@mui/material';
import { Sigma } from 'lucide-react';
import AnnotationToolbarEntry from '~/components/toolbar/shared/AnnotationToolbarEntry';
import IntensityPanel from './IntensityPanel';

const WINDOW_WIDTH = 440;

/**
 * Toolbar entry for the intensity-analysis tool. One entry for both shapes: a
 * line samples along a path and plots it, a circle samples an area and
 * summarises it, but both read the same quantity off the same image.
 *
 * @param allowCircle false on the dose step, where a circle labelled in HU
 *   beside a dose distribution would invite being read as a dose statistic
 *   (SR-WOR-H-17-5). The line shape stays, because it plots the dose it is
 *   drawn over rather than reporting a bare number next to it.
 */
export default function IntensityTool({
    allowCircle = true,
}: {
    allowCircle?: boolean;
}) {
    return (
        <AnnotationToolbarEntry
            tool="intensity"
            icon={<Sigma />}
            tooltipId="intensity.tooltip"
            titleId="intensity.title"
            testId="intensity-tool-button"
            width={WINDOW_WIDTH}
        >
            <Box sx={{ maxHeight: '80vh', overflowY: 'auto' }}>
                <IntensityPanel allowCircle={allowCircle} />
            </Box>
        </AnnotationToolbarEntry>
    );
}
